import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Enviar el token tambien por cabecera: los navegadores bloquean cookies de terceros (onrender.com)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("cb_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function fileUrl(path, token) {
  const t = token || localStorage.getItem("cb_token") || "";
  return `${API}/files/${path}?auth=${encodeURIComponent(t)}`;
}

export default api;
